module.exports = __webpack_public_path__ + "static/media/27.7882988.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/27.wav
// module id = 3WQ/
// module chunks = 0